import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const TicketOutlineIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 12 12" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89795 1.5001C7.56091 2.20958 6.83776 2.7001 6.00004 2.7001C5.16233 2.7001 4.43917 2.20958 4.10213 1.5001H3.15005C2.90152 1.5001 2.70005 1.70157 2.70005 1.9501L2.70006 10.0501C2.70006 10.2986 2.90153 10.5001 3.15006 10.5001H4.10214C4.43918 9.79061 5.16233 9.3001 6.00005 9.3001C6.83777 9.3001 7.56092 9.79061 7.89796 10.5001H8.85005C9.09858 10.5001 9.30005 10.2986 9.30005 10.0501L9.30004 1.9501C9.30004 1.70157 9.09857 1.5001 8.85004 1.5001H7.89795ZM7.20004 0.600098C7.20004 1.26284 6.66279 1.8001 6.00004 1.8001C5.3373 1.8001 4.80005 1.26284 4.80005 0.600098H3.15005C2.40446 0.600098 1.80005 1.20451 1.80005 1.9501L1.80006 10.0501C1.80006 10.7957 2.40447 11.4001 3.15006 11.4001H4.80006C4.80006 10.7374 5.33731 10.2001 6.00005 10.2001C6.66279 10.2001 7.20005 10.7374 7.20005 11.4001H8.85005C9.59563 11.4001 10.2 10.7957 10.2 10.0501L10.2 1.9501C10.2 1.20451 9.59562 0.600098 8.85004 0.600098H7.20004Z"
        fill={props.fill ?? '#091218'}
      />
    </SvgWrapper>
  );
};
